import React from "react";
import OrganizationsComponent from "../../../components/Admin/Organizations";

export default function AdminOrganizationsPage() {
    return <OrganizationsComponent />;
}
